/* Luca Bianchi theme — interazioni minime, vanilla JS */
(function(){
  // ---------- Mobile drawer ----------
  var burger=document.querySelector('[data-burger]'),
      drawer=document.querySelector('[data-drawer]');
  if(burger&&drawer){
    var closeD=function(){drawer.classList.remove('open');drawer.setAttribute('aria-hidden','true');burger.setAttribute('aria-expanded','false');document.body.style.overflow='';};
    burger.addEventListener('click',function(){drawer.classList.add('open');drawer.setAttribute('aria-hidden','false');burger.setAttribute('aria-expanded','true');document.body.style.overflow='hidden';});
    drawer.querySelectorAll('[data-close],a').forEach(function(a){a.addEventListener('click',closeD);});
  }

  // ---------- Scroll reveal ----------
  function reveals(){return document.querySelectorAll('.lb-reveal:not(.in)');}
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
    reveals().forEach(function(el){io.observe(el);});
  }else{reveals().forEach(function(el){el.classList.add('in');});}

  // ---------- Product gallery ----------
  var main=document.querySelector('[data-pdp-main]');
  if(main){
    document.querySelectorAll('[data-pdp-thumb]').forEach(function(t){
      t.addEventListener('click',function(){main.src=t.dataset.full||t.src;});
    });
  }

  // ---------- Variante: aggiorna prezzo e disponibilità ----------
  var vsel=document.querySelector('[data-variant-select]');
  if(vsel){
    vsel.addEventListener('change',function(){
      var opt=vsel.options[vsel.selectedIndex];
      var priceEl=document.querySelector('[data-price-value]');
      if(priceEl&&opt.dataset.price){priceEl.textContent=opt.dataset.price;}
      var submit=document.querySelector('#lb-pdp-form [name="add"]');
      if(submit){
        var ok=opt.dataset.available==='true';
        submit.disabled=!ok;
        submit.innerHTML=ok?'Aggiungi al carrello <span class="lb-arr">→</span>':'Esaurito';
      }
    });
  }

  // ---------- Quantity steppers ----------
  document.querySelectorAll('[data-qty]').forEach(function(box){
    var input=box.querySelector('input');
    box.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click',function(){
        var v=parseInt(input.value||'1',10);
        v=(b.dataset.step==='down')?Math.max(parseInt(input.min||'1',10),v-1):v+1;
        input.value=v;
        if(input.dataset.autosubmit){input.form.requestSubmit?input.form.requestSubmit():input.form.submit();}
      });
    });
  });

  // ---------- Toast ----------
  var toast=document.querySelector('[data-toast]'),toastTimer;
  function showToast(html){
    if(!toast)return;
    toast.innerHTML=html;
    toast.hidden=false;
    requestAnimationFrame(function(){toast.classList.add('show');});
    clearTimeout(toastTimer);
    toastTimer=setTimeout(function(){toast.classList.remove('show');setTimeout(function(){toast.hidden=true;},350);},4200);
  }

  // ---------- Carrello: aggiunta AJAX senza lasciare la pagina ----------
  function refreshCartCount(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          el.textContent=cart.item_count;
          el.hidden=cart.item_count===0;
        });
      }).catch(function(){});
  }
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
    var ajaxOff=false;
    form.addEventListener('submit',function(e){
      if(ajaxOff||!window.fetch)return; // fallback: submit classico
      // Sul carrello vero e proprio (pagina /cart) lasciamo la navigazione standard
      e.preventDefault();
      var btn=form.querySelector('[name="add"]');
      var old=btn?btn.innerHTML:'';
      if(btn){btn.disabled=true;btn.innerHTML='Un attimo…';}
      var restore=function(){if(btn){btn.disabled=false;btn.innerHTML=old;}};
      fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}})
        .then(function(r){
          if(!r.ok){return r.json().then(function(d){throw d;});}
          return r.json();
        })
        .then(function(item){
          restore();
          refreshCartCount();
          showToast('<b>'+(item.product_title||'Prodotto')+'</b> aggiunto al carrello. <a href="/cart">Vai al carrello →</a>');
        })
        .catch(function(err){
          restore();
          if(err&&err.description){showToast(err.description);}
          else{ajaxOff=true;form.submit();}
        });
    });
  });

  // ---------- Banner cookie (API Customer Privacy di Shopify) ----------
  var banner=document.querySelector('[data-cookie-banner]');
  function showBanner(){if(banner){banner.hidden=false;}}
  function hideBanner(){if(banner){banner.hidden=true;}}
  function localChoice(){try{return localStorage.getItem('lb-cookie-choice');}catch(e){return null;}}
  function setLocalChoice(v){try{localStorage.setItem('lb-cookie-choice',v);}catch(e){}}

  function applyConsent(granted){
    var done=function(){setLocalChoice(granted?'granted':'denied');hideBanner();};
    var api=window.Shopify&&window.Shopify.customerPrivacy;
    if(api&&api.setTrackingConsent){
      try{
        // API granulare (versioni recenti dell'API Customer Privacy)
        api.setTrackingConsent({analytics:granted,marketing:granted,preferences:granted,sale_of_data:granted},done);
      }catch(e){
        try{api.setTrackingConsent(granted,done);}catch(e2){done();}
      }
    }else{done();}
  }

  function initConsent(forceShow){
    if(!banner)return;
    var boot=function(){
      if(forceShow){showBanner();return;}
      var api=window.Shopify&&window.Shopify.customerPrivacy;
      if(api){
        var should=false;
        try{
          if(api.shouldShowBanner){should=api.shouldShowBanner();}
          else if(api.shouldShowGDPRBanner){should=api.shouldShowGDPRBanner();}
          else{should=!localChoice();}
        }catch(e){should=!localChoice();}
        if(should&&!localChoice()){showBanner();}
      }else if(!localChoice()){
        showBanner();
      }
    };
    if(window.Shopify&&window.Shopify.loadFeatures){
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(){boot();});
    }else{boot();}
  }
  if(banner){
    var acc=banner.querySelector('[data-cookie-accept]'),dec=banner.querySelector('[data-cookie-decline]');
    if(acc)acc.addEventListener('click',function(){applyConsent(true);});
    if(dec)dec.addEventListener('click',function(){applyConsent(false);});
    initConsent(false);
  }
  document.querySelectorAll('[data-cookie-prefs]').forEach(function(b){
    b.addEventListener('click',function(){initConsent(true);});
  });
})();
